import React, { createContext, useContext, useMemo, useEffect } from 'react';
import axios from 'axios';

const ApiContext = createContext({});

export const ApiProvider = ({ children }) => {
    const API_BASE_URL = 'https://api.zeroxone.my/api'; 
    
    const api = useMemo(() => {
        const instance = axios.create({
            baseURL: API_BASE_URL,
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            },
        });

        // Interceptor: Jika 503, terus redirect ke /maintenance
        instance.interceptors.response.use(
            (response) => response,
            (error) => {
                if (error.response?.status === 503 && window.location.pathname !== '/maintenance') {
                    // Simpan lokasi asal sebelum kena tendang ke maintenance
                    localStorage.setItem('redirect_back', window.location.pathname);
                    window.location.href = '/maintenance';
                }
                return Promise.reject(error);
            }
        );

        return instance;
    }, [API_BASE_URL]);

    // HEARTBEAT: Check status maintenance setiap 30 saat
    useEffect(() => {
        const checkMaintenanceStatus = async () => {
            try {
                const res = await api.get('/maintenance/check-status');
                
                // JIKA Maintenance ON (1)
                if (res.data.is_active === 1 && window.location.pathname !== '/maintenance') {
                    localStorage.setItem('redirect_back', window.location.pathname);
                    window.location.href = '/maintenance';
                }
                // JIKA Maintenance OFF (0) dan kita berada di /maintenance
                else if (res.data.is_active === 0 && window.location.pathname === '/maintenance') {
                    const prevPath = localStorage.getItem('redirect_back') || '/';
                    localStorage.removeItem('redirect_back');
                    window.location.href = prevPath; // Bawa balik ke page asal
                }
            } catch (err) {
                // Biarkan error, interceptor akan handle jika 503
            }
        };

        const interval = setInterval(checkMaintenanceStatus, 30000); // 30 saat
        return () => clearInterval(interval);
    }, [api]);

    return (
        <ApiContext.Provider value={{ api, API_BASE_URL }}>
            {children}
        </ApiContext.Provider>
    );
};

export const useApi = () => {
    const context = useContext(ApiContext);
    if (!context || !context.api) {
        throw new Error('useApi must be used within an ApiProvider');
    }
    return context;
};